import { Col, Layout, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "./dashboardLayout.css";
import NavHeader from "./navHeader.js";
import { Content } from "antd/lib/layout/layout.js";
import Sider from "antd/lib/layout/Sider.js";
import logoWhiteBg from '../../assets/images/logoWhiteBg.png'
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import collapseLogo from '../../assets/images/collapseLogo.png'
import TopHeader from "./topHeader.js";
import useMedia from "use-media";

const { Header } = Layout;

const siderStyle = {
  overflow: 'hidden',
  height: '100vh',
  position: 'fixed',
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: 'thin',
  scrollbarGutter: 'stable',
  zIndex: '30',
  background: 'black',
  color: 'white',
  paddingTop: 10,
  paddingLeft: 0,
  paddingRight: 5,
  paddingBottom: 10
};

const DashboardLayout = ({ expandible, children }) => {
  const location = useLocation();
  const locationPathname = location.pathname;
  const [collapsed, setCollapsed] = useState(false);
  const isTablet = useMedia({ minWidth: "600px" });

  useEffect(() => {
    if (locationPathname == '/analysis') {
      setCollapsed(true)
    }
  }, [locationPathname])

  return locationPathname !== "/login" ? (
    // <Layout className="dashboard-layout">
    //   <Layout className="dashboard-main">
    //     {/* <Header className={"dashboard-header"}>
    //       <NavHeader />
    //     </Header> */}
    //     <SideBar />
    //     <Layout>
    //       <Content>
    //         <div className="dashboard-wrapper">
    //           <div
    //             className={`dashboard-main-content`}
    //             style={{
    //               boxShadow:
    //                 locationPathname !== "/dashboard"
    //                   ? "0px 3px 10px #0000001A"
    //                   : "none",
    //             }}
    //           >
    //             <Outlet />
    //           </div>
    //         </div>
    //       </Content>
    //     </Layout>
    //   </Layout>
    // </Layout>
    <Layout hasSider>
      <Sider
        style={siderStyle}
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        breakpoint="lg"
        collapsedWidth={80}
        width={230}
        trigger={null}
      >
        <Row className="sidebar-content" justify="space-between">
          <Col lg={2} md={2} sm={2} xs={2} className="trigger-container">
            <div className="trigger-sidebar" onClick={() => setCollapsed(!collapsed)}>
              {
                collapsed ?
                  <IoIosArrowForward />
                  :
                  <IoIosArrowBack />
              }
            </div>
          </Col>
          <Col lg={21} md={21} sm={21} xs={21} className="sidebar-items">
            {
              collapsed ?
                <img src={collapseLogo} className="collapse-logo" />
                :
                <img src={logoWhiteBg} className="img-dimensions" />
            }
            <NavHeader isCollapsed={collapsed} />
          </Col>
        </Row>
      </Sider>
      <Layout
      >
        <Header className="main-header-style">
          <TopHeader isTablet={isTablet} />
        </Header>

        <Content className="main-content-style">
          <div
            className={`dashboard-wrapper ${collapsed ? 'dashboard-left-spacing' : 'dashboard-spacing'}`}>
            <div
              className={`dashboard-main-content ${locationPathname !== '/dashboard' ? 'dashboard-boxshadow' : ''}`}
            >
              <Outlet />
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  ) : null;
};
export default DashboardLayout;
